import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';

var _ref = /*#__PURE__*/React.createElement(View, null);

export const SpecificDaysPDF = ({
  carePlan
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width20, styles.paddingRightPointOneCm]
}, carePlan && carePlan.daysOfWeek && /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, `${carePlan.daysOfWeek}`) || _ref);